import React, { FC, Fragment } from 'react';
import { FontColor, Headline2, Headline4, TextDefault } from '../../../Text';
import { Flexbox, FlexboxVertical } from '../../../Layout';
import styled from 'styled-components';
import { SiteNavigationItem, StyledSubNavigationItem } from '../../../SiteNavigationItem';
import { SiteNavigationBox, SiteNavigationContent } from '../../../SiteNavigationBox';
import { Product } from '../../../../../interfaces/Product';
import { parseProductColorSet } from '../../icons/ProductIconWrapper';
import { useAttachment } from '../../../../../utils/Attachments';

const MetaInfoWrapper = styled(FlexboxVertical)`
  margin: .25rem 0 2.5rem;
  
  ${Headline2}, ${Headline4} {
    text-align: start;
    margin-bottom: 1.25rem;
  }
`;

const CertificatesPanel = styled(Flexbox)`
  justify-content: flex-start;
  align-items: flex-start;
  
  ${TextDefault} {
    flex: 1;
    padding: 0 4.5rem 0 0;
  }
  
  ${SiteNavigationContent} {
    padding: 1.5rem 2rem 2rem 1.5rem;
    min-width: 0;
    
    li {
      margin: 0 0 .75rem 0;

      &::after {
        display: none;
      }
      
      &:last-child {
        margin: 0;
      }
    }
    
    ${StyledSubNavigationItem} {
      padding: 0;
    }
  }
`;

interface Props {
  product?: Product;
  visible?: boolean;
}
export const ProductDetailCertificatesSection: FC<Props> = ({ product, ...props }) => {
  const accentColor = parseProductColorSet(product?.metaProduct?.colorSet);

  return (
    <MetaInfoWrapper>
      <FontColor color={accentColor}><Headline2>{ product?.metaProduct?.productCertificates?.title /* Das kann sich sehen lassen */}</Headline2></FontColor>

      <CertificatesPanel>

        <TextDefault>
          {
            product?.metaProduct?.productCertificates?.text?.map((item, index) => (
              <Fragment key={index}>
                {
                  index > 0 && <><br/><br/></>
                }
                {
                  item
                }
              </Fragment>
            ))
          }
        </TextDefault>

        {
          product?.metaProduct?.productCertificates?.certificatesIds?.length > 0
          &&
          <SiteNavigationBox headline={'Download'}>
            {
              product?.metaProduct?.productCertificates?.certificatesIds?.map((item) => (
                <CertificateItem id={item} />
              ))
            }
          </SiteNavigationBox>
        }

      </CertificatesPanel>

    </MetaInfoWrapper>
  );
}

const CertificateItem: FC<{ id: string }> = ({ id }) => {
  const certificate = useAttachment(id);

  return (
    <SiteNavigationItem item={{
      icon: 'pdf',
      text: certificate?.fileName?.replace('certificate__', '') || '',
      actionFn: () => {
        const dataStr = certificate?.dataUrl;
        if (dataStr) {
          // const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(tempProduct.metaProduct));
          const dlAnchorElem = document.createElement('a');
          dlAnchorElem.setAttribute('href', dataStr);
          dlAnchorElem.setAttribute('download', `${certificate?.fileName?.replace('certificate__', '') || 'certificate.pdf'}`);
          dlAnchorElem.click();
        }
      },
    }} />
  )
}
